import { IonButton } from '@ionic/react';
import styles from './PercentageButton.module.css';

type Props = {
  percentage: number;
  percentageHandler: (percentage: number) => void;
};

const PercentageButton: React.FC<Props> = ({ percentage, percentageHandler }) => {
  return (
    <IonButton
      className={styles.percentageButton}
      id="crypto-modal"
      type="submit"
      shape="round"
      size="small"
      onClick={() => percentageHandler(percentage)}
    >
      <p className={styles.percentageButtonText}>{`${percentage}%`}</p>
    </IonButton>
  );
};
export default PercentageButton;
